import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { IoArrowBackCircle } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaTrash, FaToggleOn, FaToggleOff } from 'react-icons/fa';

const CreateNewEvent = () => {
    const [eventName, setEventName] = useState('');
    const [file, setFile] = useState(null);
    const [events, setEvents] = useState([]);
    const [error, setError] = useState('');
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setUser(parsedUser);
        } else {
            console.log('No user data found in session storage');
        }
    }, []);



    useEffect(() => {
        if (user && user.id) {
            fetchEvents();
        } else {
            console.log('User is missing or incomplete');
        }
    }, [user]);


    const fetchEvents = async () => {
        if (!user || !user.id) {
            setError('User ID is missing');
            console.error('User ID is missing');
            return;
        }
        try {
            setLoading(true);
            const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
            setEvents(response.data);
        } catch (error) {
            setError('Error fetching events');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!eventName) {
            setError('Please provide an event name.');
            return;
        }
        const formData = new FormData();
        formData.append('name', eventName);
        if (file) { formData.append('file', file); }
        if (user) { formData.append('userId', user.id); }
        formData.append('flag', '1');
        try {
            setLoading(true);
            if (selectedEvent) {
                await axios.put(`https://rvapi.emedha.in/pages/api/api/events/${selectedEvent.id}`, formData);
            } else {
                await axios.post('https://rvapi.emedha.in/pages/api/api/events', formData);
            }
            fetchEvents();
            setEventName('');
            setFile(null);
            setSelectedEvent(null);
        } catch (error) {
            setError('Error saving event');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };



    const handleEdit = (event) => {
        setSelectedEvent(event);
        setEventName(event.name);
    };

    const handleDelete = async (eventId) => {
        try {
            await axios.delete(`https://rvapi.emedha.in/pages/api/api/events/${eventId}`);
            fetchEvents();
        } catch (error) {
            setError('Error deleting event');
            console.error(error);
        }
    };
    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    const toggleFlag = async (eventId, newFlag) => {
        if (!user || !user.id) {
            console.error('User ID missing');
            return;
        }
        try {
            await axios.put(`https://rvapi.emedha.in/pages/api/api/events/${eventId}/flag`, {
                flag: newFlag,
                userId: user.id
            });
            fetchEvents();
        } catch (error) {
            setError('Error toggling flag');
            console.error(error);
        }
    };

    return (
        <>
            <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', }}>
                <img src={events.find((event) => event.flag === 1)?.file || ''} alt="Logo" style={{ width: '100px' }} />
                <div style={{ flexGrow: 1, textAlign: 'center' }}>
                    <h2 style={{ color: '#333', fontSize: '24px', fontWeight: '600', }} >
                        {events && events.length > 0 ? events[0].name : 'No event available'}
                    </h2>
                </div>
            </div>

            <div className=" mt-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: 'solid 2px black', borderRadius: '20px', padding: '10px' }}>
                <IoArrowBackCircle onClick={handleBack} size={45} style={{ cursor: 'pointer', borderRadius: '20px' }} />
                <h2 className="text-center" style={{ flexGrow: 1, textAlign: 'center', margin: 0 }}>CREATE or UPDATE EVENT</h2>
            </div>

            <div className="container mt-4">
                <form onSubmit={handleSubmit} className="mb-4 mt-5">
                    <div className="row">
                        <div className="col-4">
                            <div className="form-group">
                                <label>Event Name:</label>
                                <input type="text" value={eventName} onChange={(e) => setEventName(e.target.value)} placeholder="Enter event name" className="form-control" />
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="form-group">
                                <label>Upload Company logo File:</label>
                                <input type="file" onChange={handleFileChange} className="form-control" />
                            </div>
                        </div>
                        <div className="col-4 mt-4">
                            {error && <p style={{ color: 'red' }}>{error}</p>}
                            <button type="submit" className="btn btn-primary" disabled={loading} >
                                {selectedEvent ? 'Update Event' : 'Create Event'}
                            </button>
                        </div>
                    </div>
                </form>

                <h2>Event List</h2>
                {loading && <p>Loading events...</p>}
                {!loading && events.length === 0 && <p>No events available.</p>}

                <table className="table table-bordered">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">Event Name</th>
                            <th scope="col">File</th>
                            <th scope="col">Activate</th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {events.map((event) => (
                            <tr key={event.id}>
                                <td>{event.name}</td>
                                <td><img src={event.file} width="100" alt="Event File" /></td>
                                <td>
                                    <button
                                        onClick={() => toggleFlag(event.id, event.flag === 1 ? 0 : 1)}
                                        className={`btn btn-sm ${event.flag === 1 ? 'btn-success' : 'btn-secondary'}`}
                                        title={event.flag === 1 ? 'Click to Deactivate' : 'Click to Activate'}
                                    >
                                        {event.flag === 1 ? <FaToggleOn /> : <FaToggleOff />}
                                    </button>
                                </td>
                                <td>
                                    <button onClick={() => handleEdit(event)} className="btn btn-warning btn-sm me-2" title="Edit"><FaEdit /> </button>
                                    <button onClick={() => handleDelete(event.id)} className="btn btn-danger btn-sm" title="Delete"><FaTrash /> </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <footer style={{ position: 'fixed', left: '0', bottom: '0', width: '100%', padding: '20px 0', backgroundColor: '#333', color: 'white', textAlign: 'center', fontSize: '14px', zIndex: '1000', }}>
                <p>© 2025 E-medha technologies. All rights reserved.</p>
            </footer>
        </>
    );
};

export default CreateNewEvent;
